<template>
  <vs-table :data="data">
    <template slot="header">
      <h3 class="px-2">
        {{ title | upperCase }}
      </h3>
      <div class="con-input-search vs-table--search">
        <input
          class="input-search vs-table--search-input"
          type="text"
          v-model="text"
          @keypress.enter="search"
        />
        <vs-icon icon="search"></vs-icon>
      </div>
    </template>
    <template slot="thead">
      <vs-th>
        {{ $t('request_date') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('start_date') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('end_date') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('status') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('comment') | capitalize }}
      </vs-th>
      <th class="qb-sticky"></th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td>
          {{ formatDate(data[i].request_date) }}
        </vs-td>
        <vs-td>
          {{ formatDate(data[i].start_date) }}
        </vs-td>
        <vs-td>
          {{ formatDate(data[i].end_date) }}
        </vs-td>

        <vs-td>
          <vs-button
            :color="data[i].status_color.substr(0, 7)"
            text-color="white"
            type="filled"
            size="small"
            disabled
          >
            {{ $t(data[i].status_name) | upperCase }}
          </vs-button>
        </vs-td>
        <vs-td>
          {{ data[i].comment | upperCase }}
        </vs-td>
        <vs-td>
          <div>
            <RepseFileViewer
              :request_id="data[i].id"
              :title="`${data[i].start_date}`"
              v-if="data[i].has_documents == 1"
            />

            <RepseValidateDoc
              :documentID="data[i].id"
              :statusRequest="statusRequest"
              @refresh="refresh"
              v-if="data[i].status_id == '2' && data[i].has_documents == 1"
            />

            <RepseUploadFile
              :documentID="data[i].id"
              :statusRequest="statusRequest"
              @refresh="refresh"
              v-if="data[i].status_id == '1'"
            />

            <action-icon
              icon="TrashIcon"
              :tooltip="$t('delete')"
              v-if="hasPermission(['IU REPSE DELETE'])"
              @click="confirmDelete(data[i])"
            />
          </div>
        </vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>
      
      <script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ColorIcon from '@/views/qb-components/ColorIcon'
import mixins from '@/mixins'
import ThSort from '@/views/components/ThSort'
import RepseUploadFile from './RepseUploadFile.vue'
import RepseValidateDoc from './RepseValidateDocModal.vue'
import RepseFileViewer from './RepseFileViewer.vue'
import repse from '../../requests/repse.js'

export default {
  components: {
    ActionIcon,
    ColorIcon,
    ThSort,
    RepseUploadFile,
    RepseValidateDoc,
    RepseFileViewer,
  },
  data() {
    return {
      text: '',
      statusRequest: null,
      request: {},
    }
  },
  methods: {
    handleClickSort: function (e) {
      this.$emit('sort', e)
    },
    infiniteHandler: function (isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    uploadFile: function () {
      this.$emit('upload')
    },
    search: function () {
      this.$emit('search', this.text)
    },
    showFile: function () {
      this.$emit('showFile')
    },
    validate: function () {
      this.$emit('validate')
    },
    refresh: function () {
      this.$emit('refresh')
    },
    getRequestsStatus: function () {
      repse
        .getRequestsStatus()
        .then((response) => {
          this.statusRequest = response.data.status
        })
        .catch((response) => {
          this.showValidationErrors(response)
        })
    },
    confirmDelete: function (request) {
      this.request = Object.assign({}, request)
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$i18n.messages[this.$i18n.locale].confirm,
        text: this.$i18n.messages[this.$i18n.locale].confirm_message,
        acceptText: this.$i18n.messages[this.$i18n.locale].delete,
        cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
        accept: this.deleteRequest,
      })
    },
    deleteRequest: function (request) {
      const data = { request_id: this.request.id }
      this.$emit('delete', data)
    },
  },
  mounted: function () {
    this.getRequestsStatus()
  },
  mixins: [mixins],
  props: {
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
      
      <style>
</style>
      